import React, { createContext, useState, useEffect } from "react";
import { AppContextProps, AppProviderProps} from "../models/models";
import { fetchData } from "../services/dataService";

export const AppContext = createContext<AppContextProps | undefined>(undefined);

export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {

  const [scientificCommittee, setScientificCommittee] = useState<string>();
  
  const [state, setState] = useState<any>({
    data: null,
    fetching: false,
    error: false
  });

  const setFetching = (fetching: boolean) => {
    setState((prevState: any) => ({
      ...prevState,
      fetching,
    }));
  };

  const updateScientificCommittee = (scientificCommittee: string) => {
    setScientificCommittee(scientificCommittee);
  }

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await fetchData(scientificCommittee, setFetching);
        setState((prevState: any) => ({
          ...prevState,
          data: data,
          error: false
        }));
      } catch (error) {
        console.error("Errore nel caricamento dei dati:", error);
        setState((prevState: any) => ({
          ...prevState,
          data: null,
          error: true
        }));
      }
    };

    loadData();
  }, [scientificCommittee]);

  return (
    <AppContext.Provider value={{ state, setFetching, updateScientificCommittee }}>
      {children}
    </AppContext.Provider>
  );
};